import { Button, DatePicker, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import {
    createExpenseType,
    editOrDeleteExpenseEntry,
    getExpenseTypes,
} from "../../API  Functions/ExpenseManagementFunctions";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
const { Option } = Select;

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 999,
    },
    container: {
        width: "500px",
        padding: "30px",
        borderRadius: "18px",
        margin: "0 auto",
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
    },
    input: {
        width: "100%",
        marginBottom: "20px",
    },
};

const EditExpenseModal = ({ isOpen, onClose, expense, onUpdate }) => {
    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
    const company_id = useSelector((state) => state?.login?.user?.result?.company_id);
    const { t } = useTranslation();

    const [expenseTypes, setExpenseTypes] = useState([]);
    const [expenseType, setExpenseType] = useState(expense?.expense_type || "");
  const [date, setDate] = useState(expense?.date ? dayjs(expense.date, "YYYY-MM-DD") : null);
    const [remarks, setRemarks] = useState(expense?.remarks || "");
    const [amount, setAmount] = useState(expense?.amount || "");
    const [newType, setNewType] = useState("");
    const [isCreatingType, setIsCreatingType] = useState(false);

    useEffect(() => {
    if (expense) {
        setExpenseType(expense.expense_type || "");
  setDate(expense.date ? dayjs(expense.date, "YYYY-MM-DD") : null);
        setRemarks(expense.remarks || "");
        setAmount(expense.amount || "");
    }
}, [expense, isOpen]);

    console.log("date===+>",date);
    

    // Fetch expense types
    const fetchTypes = async () => {
        const res = await getExpenseTypes(company_id);
        setExpenseTypes(res?.result?.expense_types || []);
    };

    useEffect(() => {
        if (isOpen) {
            fetchTypes();
        }
    }, [isOpen]);

    const handleSave = async () => {
        if (!expenseType || !date || !amount) {
            toast.error("Please fill all required fields");
            return;
        }

        const payload = {
            user_id,
            company_id,
            record_id: expense.id,
            expense_date: date.format("YYYY-MM-DD"),
            expense_type: expenseType,
            amount: Number(amount),
            payment_method: "", // Optional if not used
            description: remarks || "",
        };

        const res = await editOrDeleteExpenseEntry(payload);
        if (res?.result?.status_code === 200) {
            toast.success("Expense updated successfully");
            onUpdate();
            onClose();
        } else {
            toast.error("Failed to update expense");
        }
    };

    const handleCreateType = async () => {
        if (!newType) return toast.error("Enter new type");
        const res = await createExpenseType({company_id: company_id, name: newType });
        if (res?.result?.status_code === 200) {
            toast.success("Expense type created");
            setIsCreatingType(false);
            setNewType(newType);
            fetchTypes();
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <div style={styles.overlay} onClick={onClose}></div>
            <div style={styles.container}>
                <h2 className="text-xl font-bold mb-4">{t("Edit Expense")}</h2>
                  <div className="flex flex-col">
                                        <label className="text-sm mt-2 mb-1">{t("Expense Date")}</label>
                                        <DatePicker
                                            style={{ width: "100%" }}
                                            placeholder={t("Select Date")}
                                            value={date}
                                             onChange={(d) => setDate(d)}
                                            className="h-10 mb-2"
                                            disabledDate={(current) => current && current > moment().endOf("day")}  // <- Prevent future dates
                
                                        />
                                    </div>

                {/* Amount */}
 <div className="flex flex-col">
                        <label className="text-sm mt-2 mb-1">{t("Amount")}</label>
                        <Input
                            type="number"
                            placeholder={t("Enter Amount")}
                            value={String(amount)}
                    onChange={(e) => setAmount(e.target.value)}
                            className="h-10 mb-2"
                        />
                    </div>
                {/* Expense Type */}
                 <label className="text-sm mt-2 mb-1">{t("Expense Type")}</label>
                {/* {!isCreatingType ? ( */}
                    <Select
                          style={{ width: "100%" }}
                        placeholder={t("Select Expense Type")}
                        value={t(expenseType)}
                        onChange={setExpenseType}
                        className="h-10  mb-2"
                        dropdownRender={(menu) => (
                            <>
                                {menu}
                            </>
                        )}
                    >
                        {expenseTypes.map((type) => (
                            <Option key={type.id} value={type.name}>
                                {t(type.name)}
                            </Option>
                        ))}
                    </Select>
                    
                {/* ) : (
                    <div className="flex gap-2 mb-4">
                        <Input
                            value={newType}
                            onChange={(e) => setNewType(e.target.value)}
                            placeholder="Enter new type"
                        />
                        <Button onClick={handleCreateType} type="primary">
                            Save
                        </Button>
                        <Button onClick={() => setIsCreatingType(false)}>Cancel</Button>
                    </div>
                )} */}

                {/* Remarks */}
               <label className="text-sm mt-2 mb-1">{t("Remark")}</label>
                <Input.TextArea
                    style={styles.input}
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                />

                {/* <div className="flex justify-end gap-3">
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" onClick={handleSave}>
                        Save
                    </Button>
                </div> */}
                <div className="flex justify-end gap-4">
                    <button
                        onClick={onClose}
                        className={`px-4 py-2 font-semibold text-sm border rounded-lg bg-white text-primaryBlue border-primaryBlue hover:bg-red-600`}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSave}
                        className={`px-4 py-2 font-semibold text-sm border rounded-lg bg-primaryBlue text-white border-primaryBlue hover:bg-red-600`}
                    >
                        {t("Save")}
                    </button>
                </div>
            </div>
        </>
    );
};

export default EditExpenseModal;
